<template>
  <div class="panel-container">
    <div class="main-container">
      <div class="spot-table-wrap" v-loading="loading">
        <div class="spot-table-inner">
          <v-table
            density="compact"
            fixed-header
            height="100%"
            class="bg-transparent flex-grow-1 gm-table ops-table ops-spot-table table-com"
            style="width: 100%"
          >
            <thead>
              <tr>
                <th class="col-region">{{ $str.getKey('收益管理/地区') }}</th>
                <th class="col-month">{{ $str.getKey('收益管理/时间') }}</th>
                <th class="col-industry">{{ $str.getKey('收益管理/工业类型') }}</th>
                <th class="col-system">{{ $str.getKey('收益管理/制度') }}</th>
                <th class="col-voltage">{{ $str.getKey('收益管理/电压等级') }}</th>
                <th class="col-price text-end">{{ $str.getKey('收益管理/尖锋时段') }}</th>
                <th class="col-price text-end">{{ $str.getKey('收益管理/高峰时段') }}</th>
                <th class="col-price text-end">{{ $str.getKey('收益管理/平时段') }}</th>
                <th class="col-price text-end">{{ $str.getKey('收益管理/低谷时段') }}</th>
                <th class="col-price text-end">{{ $str.getKey('收益管理/深谷时段') }}</th>
                <th class="col-action text-end">{{ $str.getKey('收益管理/操作') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, idx) in tableData"
                :key="String(row.id || '') + '-' + idx"
                :class="{ 'tr-editing': row.beEditing }"
              >
                <td class="cell-text cell-ellipsis" :title="row.adName">{{ row.adName }}</td>
                <td class="cell-text">{{ row.month }}</td>
                <td class="cell-text">{{ industryLabelFor(row) }}</td>
                <td class="cell-text">{{ systemLabelFor(row) }}</td>
                <td class="td-voltage">
                  <el-select
                    v-if="row.beEditing"
                    v-model="row.voltageLevel"
                    size="small"
                    class="cell-voltage-select"
                    :placeholder="$str.getKey('收益管理/请选择')"
                  >
                    <el-option
                      v-for="opt in voltageLevelList"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    />
                  </el-select>
                  <span v-else class="cell-text">{{ row.voltageLevel }}</span>
                </td>
                <td class="text-end td-price">
                  <el-input-number
                    v-if="row.beEditing"
                    v-model="row.segmentInfo.sharpPrice"
                    :min="0"
                    :precision="6"
                    :step="0.1"
                    :controls="false"
                    size="small"
                    class="cell-number"
                    :placeholder="$str.getKey('收益管理/请输入电价')"
                  />
                  <span v-else class="cell-text">{{ row.segmentInfo.sharpPrice }}</span>
                </td>
                <td class="text-end td-price">
                  <el-input-number
                    v-if="row.beEditing"
                    v-model="row.segmentInfo.peakPrice"
                    :min="0"
                    :precision="6"
                    :step="0.1"
                    :controls="false"
                    size="small"
                    class="cell-number"
                    :placeholder="$str.getKey('收益管理/请输入电价')"
                  />
                  <span v-else class="cell-text">{{ row.segmentInfo.peakPrice }}</span>
                </td>
                <td class="text-end td-price">
                  <el-input-number
                    v-if="row.beEditing"
                    v-model="row.segmentInfo.flatPrice"
                    :min="0"
                    :precision="6"
                    :step="0.1"
                    :controls="false"
                    size="small"
                    class="cell-number"
                    :placeholder="$str.getKey('收益管理/请输入电价')"
                  />
                  <span v-else class="cell-text">{{ row.segmentInfo.flatPrice }}</span>
                </td>
                <td class="text-end td-price">
                  <el-input-number
                    v-if="row.beEditing"
                    v-model="row.segmentInfo.valleyPrice"
                    :min="0"
                    :precision="6"
                    :step="0.1"
                    :controls="false"
                    size="small"
                    class="cell-number"
                    :placeholder="$str.getKey('收益管理/请输入电价')"
                  />
                  <span v-else class="cell-text">{{ row.segmentInfo.valleyPrice }}</span>
                </td>
                <td class="text-end td-price">
                  <el-input-number
                    v-if="row.beEditing"
                    v-model="row.segmentInfo.deepValleyPrice"
                    :min="0"
                    :precision="6"
                    :step="0.1"
                    :controls="false"
                    size="small"
                    class="cell-number"
                    :placeholder="$str.getKey('收益管理/请输入电价')"
                  />
                  <span v-else class="cell-text">{{ row.segmentInfo.deepValleyPrice }}</span>
                </td>
                <td class="col-action-cell">
                  <div class="operate-cell">
                    <el-button v-if="!row.beEditing" size="small" jd-type="edit-text" link @click="handleOperate(row,'edit')">{{ $str.getKey('收益管理/编辑') }}</el-button>
                    <el-button v-if="row.beEditing" size="small" jd-type="cancle-text" link @click="handleOperate(row,'cancle')">{{ $str.getKey('收益管理/取消') }}</el-button>
                    <el-button v-if="row.beEditing" size="small" jd-type="confirm-text" link @click="handleOperate(row,'confirm')">{{ $str.getKey('收益管理/确定') }}</el-button>
                  </div>
                </td>
              </tr>
              <tr v-if="(tableData || []).length === 0 && !loading">
                <td class="empty-cell" colspan="11">暂无数据</td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, watch } from "vue"
import { cloneDeep } from "@/utils";
import { commitEditData } from './api/index.js';
import { industryLabelFromValue, systemLabelFromValue } from './utils/priceEnum'

const $str = window.$str;

/** 设置组件配置项 */
defineOptions({
  name: "ElecDetailsPanel"
});

/** 接收父组件信息 */
const props = defineProps({
  originData: {
    type: Object,
    default: {
      tableData: [],
    }
  },
  /** 当前页选择的业务类型：1 代理购电；3 充电桩（与详情查询一致，保存时必须带上以免串库） */
  businessPriceType: {
    type: Number,
    default: undefined,
  },
});

const emit = defineEmits(['refresh']);

const loading = ref(false); // 控制加载中动效的渲染（由父组件/外层决定是否传入；此处保留 v-loading 兜底）
const tableData = ref([]);

const voltageLevelList = [
  { label: '1kv', value: '1kv' },
  { label: '10kv', value: '10kv' },
  { label: '20kv', value: '20kv' },
  { label: '35kv', value: '35kv' },
  { label: '110kv', value: '110kv' },
  { label: '220kv', value: '220kv' },
]

function industryLabelFor(row) {
  return industryLabelFromValue(row.industryType ?? row.industry)
}

function systemLabelFor(row) {
  return systemLabelFromValue(row.systemType ?? row.type)
}

initPanel();

watch(() => props.originData.tableData, nv => {
  tableData.value = cloneDeep(nv);
}, {immediate: true});


/** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {}


/** 事件响应：编辑行 */
function handleOperate(row, operateType) {
  if (operateType === 'edit') {
    row.beEditing = true;
  } 
  if (operateType === 'cancle') {
    resetRowData(row); // 回复原始数据
    row.beEditing = false;
  }
  if (operateType === 'confirm') {
    // 提交编辑结果
    const isOk = checkDataValid(row);
    if (!isOk) {
      window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/请正确填写时段电价信息！')
      });
      return isOk;
    }
    const params = formatParamsForEdit([row]);
    commitEditData(params).then(res => {
      row.beEditing = false;
      // 通知父组件刷新数据
      emit('refresh')
    })

  }
}



/** ====== [辅助：功能方法] =================================================================== */
/** 检查数据有效性 */
function checkDataValid(data) {
  if (!data?.voltageLevel || String(data.voltageLevel).trim() === '') return false;
  const checkKeys = ['sharpPrice', 'peakPrice', 'flatPrice', 'valleyPrice', 'deepValleyPrice'];
  return checkKeys.every(key => typeof data.segmentInfo[key] === 'number');
}

/** 格式化：提交编辑结果的接口参数 */
function formatParamsForEdit(dataList) {
  const params = []
  if (Array.isArray(dataList)) {
    dataList.forEach(data => {
      const item = {
        id: data.id,
        areaName: data.adName,
        areaCode: data.adCode,
        type: data.type,
        voltageLevel: data.voltageLevel,
        monthValue: data.month,
        sharpPrice: data.segmentInfo.sharpPrice,
        peakPrice: data.segmentInfo.peakPrice,
        flatPrice: data.segmentInfo.flatPrice,
        valleyPrice: data.segmentInfo.valleyPrice,
        deepPrice: data.segmentInfo.deepValleyPrice,
      }
      // 与后端一致：0 一般工商业，1 大工业（展示用 priceEnum.industryLabelFromValue）
      const ind = data.industryType ?? data.industry
      if (ind !== undefined && ind !== null && ind !== '') {
        item.industry = ind
      }
      if (props.businessPriceType !== undefined && props.businessPriceType !== null) {
        item.priceType = props.businessPriceType
      }
      params.push(item);
    })
  }
  return params;
}

/** 重置数据：正在被编辑的行 */
function resetRowData(row) {
  const originData = props.originData.tableData.find(it => it.id === row.id);
  if (!originData) return;
  row.segmentInfo = cloneDeep(originData.segmentInfo);
  row.voltageLevel = originData.voltageLevel;
}


</script>
<style lang="scss" scoped>
.panel-container {
  --header-hight: 40px;
  & {
    width: 100%;
    height: 100%;
    background: var(--level2-bg-color);
    // padding: 10px 20px;
    border-radius: 6px;
  
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  .main-container {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-rows: 1fr;
    overflow: hidden;
    .table-com {
      height: 100%;
    }
  }

  .spot-table-wrap {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.06);
    background: rgba(255, 255, 255, 0.78);
    display: flex;
  }

  .spot-table-inner {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: visible;
  }

  /* 固定列宽铺满容器，避免大量 min-width 触发横向滚动 */
  .table-com :deep(table) {
    width: 100%;
    table-layout: fixed !important;
  }

  .table-com :deep(thead th) {
    font-size: 12px;
    line-height: 1.25;
    padding: 6px 4px;
    vertical-align: middle;
    min-width: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .table-com :deep(.col-region) {
    width: 8%;
    min-width: 0;
  }

  .table-com :deep(.col-month) {
    width: 7%;
    min-width: 0;
  }

  .table-com :deep(.col-industry) {
    width: 9%;
    min-width: 0;
  }

  .table-com :deep(.col-system) {
    width: 6%;
    min-width: 0;
  }

  .table-com :deep(.col-voltage) {
    width: 7%;
    min-width: 0;
  }

  /* 五列电价略收窄；操作列单独加宽（与 .col-action 合计约 100%） */
  .table-com :deep(.col-price) {
    width: 10.08%;
    min-width: 0;
  }

  .table-com :deep(.col-action) {
    width: 12%;
    min-width: 100px;
  }

  .table-com :deep(tbody td) {
    padding: 4px 4px;
    font-size: 12px;
    vertical-align: middle;
    min-width: 0 !important;
  }

  .table-com :deep(.cell-ellipsis) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .table-com :deep(tbody td.td-price),
  .table-com :deep(tbody td.td-voltage) {
    overflow: hidden;
    min-width: 0;
  }

  .cell-voltage-select {
    width: 100% !important;
    max-width: 100%;
    min-width: 0 !important;
  }

  .table-com :deep(.cell-voltage-select .el-select__wrapper) {
    min-height: 26px;
    height: 26px;
    padding: 0 6px;
    font-size: 12px;
  }

  /*
   * 数字框默认宽度（small 仍约 150px）会破坏 fixed 表格；关闭步进器 + 强制铺满单元格
   * :controls="false" 时仍可键盘输入与滚轮调值，校验与提交逻辑不变
   */
  .table-com :deep(.cell-number.el-input-number) {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100%;
    margin-left: auto;
    display: flex;
    vertical-align: middle;
  }

  .table-com :deep(.cell-number.el-input-number > .el-input) {
    flex: 1;
    min-width: 0;
    width: auto;
  }

  .table-com :deep(.cell-number.is-without-controls .el-input__wrapper) {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  .table-com :deep(.cell-number .el-input__wrapper) {
    min-height: 26px;
    height: 26px;
    font-size: 12px;
  }

  .table-com :deep(.cell-number .el-input__inner) {
    font-size: 12px;
    text-align: right;
  }

  /* 操作列：与表头 text-end 一致，禁止 overflow:hidden 裁切 link 文字 */
  .table-com :deep(tbody td.col-action-cell) {
    padding: 4px 8px;
    overflow: visible;
    white-space: nowrap;
    vertical-align: middle;
    text-align: right;
  }

  .operate-cell {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    white-space: nowrap;
    line-height: 1.2;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .operate-cell :deep(.el-button.is-link) {
    padding: 2px 6px;
    margin: 0;
    font-size: 12px;
    flex-shrink: 0;
  }

  .operate-cell :deep(.el-button[jd-type='edit-text']) {
    color: #3a68ff;
  }

  .operate-cell :deep(.el-button[jd-type='cancle-text']) {
    color: rgba(46, 46, 46, 0.65);
  }

  .operate-cell :deep(.el-button[jd-type='confirm-text']) {
    color: #3a68ff;
  }

  .table-com :deep(tr.tr-editing td) {
    vertical-align: middle;
  }

  .cell-text {
    color: rgba(46, 46, 46, 0.86);
  }

  .empty-cell {
    text-align: center;
    color: rgba(46, 46, 46, 0.5);
    padding: 18px 0;
  }
   /* 按钮统一白字（本页 UI 规范） */
   :deep(.el-button:not(.is-link)) {
    --el-button-text-color: #fff;
    color: #fff;
  }
}


</style>
